import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const CONTACT_SUPPORT = `/support`;


export const getUserInfo = createAsyncThunk(
  "getUserInfo",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${CONTACT_SUPPORT}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const contactSupport = createAsyncThunk(
  "contactSupport",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${CONTACT_SUPPORT}`, values);
      console.log('response >>>> ', response?.data);
      toast.success(response?.data?.message || "Contact Support message sent Successfully.");
      
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to send contact support message.");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);
